import { SimpleGrid } from '@chakra-ui/react';

interface SearchFormProps {
  columns: number;
}

const SearchForm: React.FC<SearchFormProps> = ({ columns, children }) => {
  return (
    <SimpleGrid columns={columns} w="100%" my="24px" spacingX={4}>
      {children}
    </SimpleGrid>
  );
};

export default SearchForm;
